module.exports = __webpack_public_path__ + "img/aa.fbe383d3.jpg";